import { PrimeIcons } from "primereact/api";

import { labelProcessing } from "_constants";

export const StateSourceEnqueued = () => {
  return (
    <div className="source-wait flex-container align-center gap-4">
      <span className={PrimeIcons.UNDO}></span>
      <small className="font-weight-600">{labelProcessing}</small>
    </div>
  );
};
